export const SET_NOTIFICATION = "notification/SET_NOTIFICATION";
export const SET_STREAM = "notification/SET_STREAM";
export const SET_NOTIFICATION_ALL = "notification/SET_NOTIFICATION_ALL";
export const SET_NOTIFICATION_TRANSIENT =
  "notification/SET_NOTIFICATION_TRANSIENT";
